(function ($) {
    /*sliders*/

    /* features slider */
    $('.features-slider').slick({
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        cssEase: 'linear',
        slidesToShow: 1
    });

    /* our-partners slider */
    $('.our-partners-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 1800,
    });

    /* testimonials slider */
    var testimonialsSlider = $('.testimonials-slider');

    testimonialsSlider.on('init', function(event, slick, currentSlide) {
        var
            cur = $(slick.$slides[slick.currentSlide]),
            next = cur.next(),
            prev = cur.prev();
        prev.addClass('slick-sprev');
        next.addClass('slick-snext');
        cur.removeClass('slick-snext').removeClass('slick-sprev');
        slick.$prev = prev;
        slick.$next = next;
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        var
            cur = $(slick.$slides[nextSlide]);
        slick.$prev.removeClass('slick-sprev');
        slick.$next.removeClass('slick-snext');
        var next = cur.next(),
            prev = cur.prev();
        prev.prev();
        prev.next();
        prev.addClass('slick-sprev');
        next.addClass('slick-snext');
        slick.$prev = prev;
        slick.$next = next;
        cur.removeClass('slick-next').removeClass('slick-sprev');
    });

    testimonialsSlider.slick({
        speed: 800,
        arrows: true,
        dots: false,
        infinite: true,
        slidesPerRow: 1,
        slidesToScroll: 1,
        centerPadding: '0',
        slidesToShow: 1,
        adaptiveHeight: true,
        customPaging: function(slider, i) {
            return '';
        }
    });

    $(window).on('load resize orientationchange', function() {
        $('.testimonials-slider').each(function () {
            var $carousel = $(this);
            if ($(window).width() > 768) {
                $carousel.removeClass('mobile').addClass('desktop');
            } else {
                $carousel.removeClass('desktop').addClass('mobile');
            }
        });
    })


    /* Find Coverage slider */

    if($('.medmal-guide-page--has-tail-sidebar').length) {
        $('.find-coverage__cards').slick({
            arrows: true,
            cssEase: 'linear',
            infinite: false,
            slidesToShow: 1.3,
            adaptiveHeight: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 920,
                    settings: {
                        slidesToShow: 2.5,
                    }
                }
            ]
        });
    } else {
        $('.find-coverage__cards').slick({
            arrows: true,
            cssEase: 'linear',
            infinite: false,
            slidesToShow: 1.2,
            adaptiveHeight: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 480,
                    settings: "unslick"
                }
            ]
        });
    }


})(jQuery);
